import Debounce from "lodash.debounce";

const selector = "[data-tabs]";
const contentSelector = "[data-tabs-content]";
const panelsSelector = "[data-tab-panel]";
const panelLoadedClass = "tab-panel--loaded";

let els = null;
let bp = 0;

function TabsComponent(breakpoint) {
	// Search for carousel elements on page
	els = document.querySelectorAll(selector);

	// If there are any, continue
	if (els.length) {
		bp = breakpoint;
		init();
	}
}

const init = () => {
	// Add resize event listener to window
	// window.addEventListener('resize', Debounce(checkPanelHeights, 500));
	window.addEventListener("resize", Debounce(checkWindowWidth, 500));

	// Loop through them
	[].forEach.call(els, function (item) {
		// Add event listener for custom event dispatched by tab link
		item.addEventListener("tab-clicked", function (e) {
			// Get id of clicked tab
			const tabId = e.detail.tabId;

			// Set data attr to current active tab
			item.dataset.tabsActive = tabId;
		});

		item.addEventListener("panels-loaded", function (e) {
			// console.log(e);

			checkPanelHeights();
		});

		// Add event listeners on tab panels to check all contents are loaded before calculating max heights
		const panels = item.querySelectorAll(panelsSelector);
		let panelsLoaded = 0;

		[].forEach.call(panels, function (panel) {
			// Listen for when carousel inside panel has mounted
			panel.addEventListener("carousel-mounted", function (e) {
				// console.log(e);

				// Add class to panel to show contents loaded
				panel.classList.add(panelLoadedClass);

				// Increment number of panels loaded
				panelsLoaded++;

				// In number of panels loaded same as number of panels
				if (panelsLoaded === panels.length) {
					// Dispatch event showing all panels loaded
					const panelsLoadedEvent = new Event("panels-loaded", {
						bubbles: true,
					});
					panel.dispatchEvent(panelsLoadedEvent);
				}
			});
		});
	});
};

// Whenever window width resized
const checkWindowWidth = () => {
	// Loop through tabs components
	[].forEach.call(els, function (item) {
		// Remove panel loaded class from tab panels
		[].forEach.call(item.querySelectorAll(panelsSelector), function (panel) {
			panel.classList.remove(panelLoadedClass);
		});

		// Remove height attribute from content container
		item.querySelector(contentSelector).removeAttribute("style");
	});

	checkPanelHeights();
};

const checkPanelHeights = () => {
	let ww = window.innerWidth;
	let pastBp = false;

	if (ww >= bp) {
		pastBp = true;
	}

	// Loop through tab components
	[].forEach.call(els, function (item) {
		const tabsContentEl = item.querySelector(contentSelector);
		let maxH = 0;

		// If window width wider than breakpoint
		if (pastBp) {
			// Loop through tab panels and find height of tallest one
			[].forEach.call(item.querySelectorAll(panelsSelector), function (panel) {
				// Get panel height
				let elH = panel.offsetHeight;

				// If panel height greater than current max height, update current max height
				if (elH > maxH) {
					maxH = elH;
				}

				// Set height of tabs content container
				tabsContentEl.style.height = maxH + "px";
			});
		}
	});
};

export default TabsComponent;
